import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function ActionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      id="project"
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image - 充满动感 */}
      <motion.div
        initial={{ scale: 1.1 }}
        animate={isInView ? { scale: 1 } : { scale: 1.1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0"
      >
        <BackgroundMedia
          videoSrc={images.action}
          imageSrc={images.actionImage}
          className="w-full h-full object-cover"
          objectPosition="center top"
        />
        {/* 渐变遮罩 - 减少遮罩强度，让logo清晰可见 */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </motion.div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
        transition={{ duration: 1.2, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center px-6 max-w-6xl"
      >
        {/* 标题 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 1.1 }}
          className="mb-6"
        >
          <span className="text-white/90 text-lg md:text-xl tracking-wider drop-shadow-2xl block mb-4">世界战争儿童关爱基金会</span>
          <h2 className="text-white text-4xl md:text-6xl lg:text-7xl mb-4 drop-shadow-2xl">
            [白鸽计划]
          </h2>
        </motion.div>
        
        {/* 副标题 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 1.3 }}
        >
          <div className="h-px bg-gradient-to-r from-transparent via-white/50 to-transparent mb-6" />
          <p className="text-white/95 text-xl md:text-3xl lg:text-4xl tracking-wide leading-relaxed drop-shadow-2xl">
            带他们离开阴影，奔向光明
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
}

